// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3283cb74","455":"e4d6f907","977":"32f536f6"}[chunkId] + ".chunk.js";
};